// =====================================================
// 📁 POSExportInvoicePanel.tsx
// =====================================================

import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { RootState } from '../../../../../store/store';

import { useSale } from '../../../../../hooks/sale/useSale';

import { useExportInvoiceSale } from '../../../../../hooks/sale/useExportInvoiceSale';

import { DOCUMENT_TYPE_CODES } from '../../../../../constants/documentTypeCodes';

import POSFiscalPrecinctSection from '../sections/POSFiscalPrecinctSection';

import POSExportRegimeSection from '../sections/POSExportRegimeSection';

import POSIncotermSection from '../sections/POSIncotermSection';

const POSExportInvoicePanel = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form } = useSale();

  const { handlerGetExportItemType } = useExportInvoiceSale();

  // =====================================================
  // 🔹 Store
  // =====================================================
  const exportItemType = useSelector(
    (state: RootState) => state.exportInvoiceSale.exportItemType
  );

  // =====================================================
  // 🔹 Flags
  // =====================================================
  const isExportInvoice =
    form?.documentType?.code === DOCUMENT_TYPE_CODES.EXPORT_INVOICE;

  // =====================================================
  // 🔹 Effects
  // =====================================================
  useEffect(() => {
    if (isExportInvoice && form?.id) {
      handlerGetExportItemType();
    }
  }, [isExportInvoice, form?.id]);

  // =====================================================
  // 🔹 Rules
  // =====================================================
  const shouldShowExtras =
    isExportInvoice && (exportItemType === 1 || exportItemType === 3);

  // =====================================================
  // 🔹 Hidden
  // =====================================================
  if (!shouldShowExtras) {
    return null;
  }

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
        mt-6

        rounded-2xl

        border
        border-stroke

        bg-white

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}
      <div
        className="
          border-b
          border-stroke

          px-5
          py-4

          dark:border-strokedark
        "
      >
        <h3
          className="
            text-sm
            font-semibold
            text-black

            dark:text-white
          "
        >
          Datos de Exportación
        </h3>

        <p
          className="
            mt-1

            text-xs
            text-body
          "
        >
          Completa la información requerida para exportación.
        </p>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}
      <div
        className="
          space-y-5

          p-5
        "
      >
        <POSFiscalPrecinctSection />

        <POSExportRegimeSection />

        <POSIncotermSection />
      </div>
    </div>
  );
};

export default POSExportInvoicePanel;
